import React from "react";
import { Chip, Group, GroupLabel, Hint, Mono } from "./ToggleChipGroup.styles";
import type { ToggleChipGroupProps } from "./ToggleChipGroup.types";

/** A wrapping group of checkbox chips. */
export const ToggleChipGroup: React.FC<ToggleChipGroupProps> = ({ id, ariaLabel, label, options, onToggle, children, className }) => (
  <Group role="group" aria-label={ariaLabel} className={className}>
    {label ? <GroupLabel>{label}</GroupLabel> : null}
    {options.map((option, index) => (
      <Chip key={option.value} htmlFor={`${id}-${index}`} $checked={option.checked} $disabled={Boolean(option.disabled)}>
        <input
          type="checkbox"
          id={`${id}-${index}`}
          checked={option.checked}
          disabled={option.disabled}
          onChange={(event) => onToggle(option.value, event.target.checked)}
        />
        {option.mono ? <Mono>{option.label}</Mono> : <span>{option.label}</span>}
        {option.hint ? <Hint>{option.hint}</Hint> : null}
      </Chip>
    ))}
    {children}
  </Group>
);

export default ToggleChipGroup;
